import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, GridProps, FormLabel, Select } from '@tq/ui-components/dist/components';

import { GenericValueLabel } from 'types';
import { MultiSelectItems } from '..';

export type MultiSelectProps = {
  label: string;
  items?: GenericValueLabel[];
  selectedItems?: GenericValueLabel[];
  handleSelect: (value: string) => void;
  handleRemoveSelection: (value: number | string) => void;
  fieldId?: string;
  isInModal?: boolean;
  allowMultiSelect?: boolean;
  disabled?: boolean;
};

export const MultiSelect: React.FC<MultiSelectProps & GridProps> = ({
  label,
  items,
  selectedItems,
  handleSelect,
  handleRemoveSelection,
  fieldId,
  isInModal,
  allowMultiSelect = true,
  disabled = false,
  ...stylingProps
}) => {
  const { t } = useTranslation('multi_select');

  const getPlaceHolderText = () => {
    if (allowMultiSelect && selectedItems?.length)
      return `${selectedItems?.length} ${t('selected', 'selected')}`;
    return selectedItems?.length ? selectedItems[0].label : `- ${t('select', 'Select')} -`;
  };

  const isSelectedItem = (item: GenericValueLabel): boolean => {
    if (selectedItems === undefined) return false;
    return selectedItems.some((sitem) => sitem.value === item.value);
  };

  return (
    <Grid {...stylingProps}>
      <FormLabel htmlFor={fieldId}>{label}</FormLabel>
      <Select
        disabled={disabled}
        inputId={fieldId}
        aria-label={label}
        mr={1}
        width='100%'
        onChange={handleSelect}
        controlShouldRenderValue={false}
        menuPortalTarget={isInModal ? null : document.body}
        placeholder={getPlaceHolderText()}
        menuZIndex={isInModal ? undefined : 3}
      >
        {items &&
          items.map((filter: GenericValueLabel) => (
            <option key={filter.value} value={filter.value} disabled={isSelectedItem(filter)}>
              {filter.label}
            </option>
          ))}
      </Select>
      {allowMultiSelect && selectedItems && (
        <MultiSelectItems selectedItems={selectedItems} onClick={handleRemoveSelection} />
      )}
    </Grid>
  );
};
